import React from "react";
import { connect } from "react-redux";
import LimitLine from "../../GameHeader/Stats/LimitLine";
import { formatNumberForceSigned } from "../../../lib/commonFunctions";

const BricksBalance = ({ bricksBalance }) => (
  <React.Fragment>
    <h3 className="title">Bricks balance</h3>
    Masons: <span className={bricksBalance.production.masons > 0 ? "positive" : ""}>
    {formatNumberForceSigned(bricksBalance.production.masons)}
    </span><br />
    {!!bricksBalance.production.guilds && <>
      Guild: <span className={"positive"}>{formatNumberForceSigned(bricksBalance.production.guilds)}</span><br />
    </>}
    <br />
    <LimitLine
      amount={bricksBalance.limit.amount}
      limit={bricksBalance.limit.limit}
      market={bricksBalance.limit.market}
    />
  </React.Fragment>
);

const mapStateToProps = state => ({
  bricksBalance: state.governorate.resourceBalances.bricks,
});

export default connect(mapStateToProps)(BricksBalance);
